// Cart math: computes net/vat/gross totals and per-rate breakdown
export function computeTotals(cart) {
    let net = 0,
        vat = 0,
        gross = 0;
    const breakdown = {};
    for (const { item, quantity } of cart) {
        const lineGross = item.unit_price * quantity;
        const r = item.vat_rate || 0;
        const lineNet = r > 0 ? lineGross / (1 + r / 100) : lineGross;
        const lineVat = lineGross - lineNet;
        net += lineNet;
        vat += lineVat;
        gross += lineGross;
        const key = String(r);
        if (!breakdown[key]) breakdown[key] = { net: 0, vat: 0, gross: 0 };
        breakdown[key].net += lineNet;
        breakdown[key].vat += lineVat;
        breakdown[key].gross += lineGross;
    }
    return {
        net: Math.round(net * 100) / 100,
        vat: Math.round(vat * 100) / 100,
        gross: Math.round(gross * 100) / 100,
        breakdown,
    };
}
